import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

/**
 * Envoltura de los formularios de alta (usuarios, activos): como página completa o como ventana modal
 * sobre el listado. El contenido (la tarjeta del asistente) es el mismo en ambos casos.
 */
export default function FormularioEnModal({ modal, onClose, children }) {
  useEffect(() => {
    if (!modal) return undefined;
    const alTeclear = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', alTeclear);
    return () => document.removeEventListener('keydown', alTeclear);
  }, [modal, onClose]);

  if (!modal) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 py-8">
        <div className="max-w-4xl mx-auto px-4">{children}</div>
      </div>
    );
  }

  return createPortal(
    <div role="dialog" aria-modal="true" className="fixed inset-0 z-[9000] overflow-y-auto bg-black/50">
      <div
        className="min-h-full flex items-start justify-center p-3 sm:p-6"
        onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      >
        <div className="relative w-full max-w-4xl my-2">
          <button
            type="button"
            onClick={onClose}
            aria-label="Cerrar"
            className="absolute top-3 right-3 z-10 p-2 rounded-lg text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );
}
